angular.module('unica_workshop_session.workshop_session_services')

.factory('WorkshopSessionCreateService', function ($http, getBaseApiURL) {

	var workshopSessionCreateService = {};

	workshopSessionCreateService.create = function ( workshopSessionData ) {

		return $http({
			method: 'POST',
			url: getBaseApiURL + '/workshop-session/create',
			data: workshopSessionData
		}).then(function(result) {

			if ( result ) {
				return result.data.workshop_session;
			}

		});

	};

	return workshopSessionCreateService;
});